setTimeout(function() {
const mNav = document.querySelector('.nav--mobile__column');

//Anchor tag
const aTag =  document.createElement('a');

aTag.classList.add('nav__mobile-accordion-opener');
aTag.href = "https://miyarisan-wellness.com/pages/hupele";
aTag.target = "_blank";
aTag.setAttribute('ref', 'noopener noreferrer');

//Main Span
const menuText = document.createElement('span')

menuText.innerHTML = "HuPele<br>愛犬・愛猫用サプリ";

//Merge those elements
aTag.appendChild(menuText);
//Append it to the parent wrapper
mNav.appendChild(aTag);
},1000)
